import { Stack } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { useLogErrorEffect } from "@src/appV2/lib/analytics/useLogErrorEffect";
import { Text } from "@src/appV2/redesign/system/ui-components";

interface DocumentSearchErrorProps {
  error: unknown;
}

export function DocumentSearchError(props: DocumentSearchErrorProps) {
  const { error } = props;

  useLogErrorEffect(APP_V2_USER_EVENTS.DOCUMENT_SEARCH_ERROR_VIEWED, { error });

  return (
    <Stack flex={1} alignItems="center" justifyContent="center" spacing={2}>
      <Text semibold variant="h5" align="center">
        Something went wrong while searching for documents
      </Text>
      <Text
        variant="body1"
        align="center"
        sx={(theme) => ({ color: theme.palette.text.secondary })}
      >
        Please try again with a different search term.
      </Text>
    </Stack>
  );
}
